module.exports = __webpack_public_path__ + "static/DisabledOverseasAndSingapore-b284fae6354d20d36691fe5d52f46c04.png";